import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUser } from '../common/currentuser.model';
import { MainStore } from '../common/main.store';
import { UserService } from '../services/user.service';

function requireUser(isAllowed: (user: CurrentUser) => boolean): CanActivateFn {
  return async () => {
    const store = inject(MainStore);
    const router = inject(Router);
    const userService = inject(UserService);

    // On a direct URL load the guard runs before MainLayoutComponent has fetched the current user.
    if (!store.currentUser.get().userName) {
      await userService.getUserInfo();
    }

    return isAllowed(store.currentUser.get()) ? true : router.parseUrl('/home');
  };
}

// Admin areas (department in DepartmentAdmins). The API enforces the same check in each handler.
export const adminGuard = requireUser(user => user.isAdmin);

// Mirrors DbTemplateAccess.MayModify: only admins in department 200 (Software Solutions).
export const dbTemplateAdminGuard = requireUser(user => user.isAdmin && user.departmentCode === '200');
